import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import DateHelper from 'src/app/helpers/date-helper';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import {
  DeserializeVoid,
  _post,
} from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class TransferSubProjectsAndImmoTasksControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      '/tours/transferSubProjectsAndImmoTasks',
      requestServices
    );
  }

  public transferSubProjectsAndImmoTasksToOtherTour(
    currentTourId: number,
    subProjectIds: number[],
    immoTaskIds: number[],
    placerId: number,
    date: Date
  ): Promise<void> {
    const request: RequestBody = {
      currentTourId: currentTourId,
      subProjectIds: subProjectIds,
      immoTaskIds: immoTaskIds,
      placerId: placerId,
      dateString: DateHelper.formatDate(date, 'yyyyMMdd'),
    };
    return this.post('', request, DeserializeVoid).toPromise();
  }
}

interface RequestBody {
  currentTourId: number;
  subProjectIds: number[];
  immoTaskIds: number[];
  placerId: number;
  dateString: string;
}
